export default __webpack_public_path__ + "static/media/logo-dho-sispack.f77154b3.svg";